/**
 * @description
 * @author: 菩萨蛮
 * @date: 2019-10-25 15:50
 * @version: V1.0.0
 */

/**
 * 列表tab状态obj转为table展示状态obj的方法
 * @param code 列表状态obj
 * @returns obj table 展示状态obj
 */
const code2obj = code => {
  const obj = Object.create(null);
  Object.values(code).map(e => {
    obj[e.CODE] = e.NAME;
    return null;
  });
  return obj;
};

const STATE_NOTICE_ORDER = {
  DRAFT: { CODE: 5, NAME: '草稿' },
  UNDELIVER: { CODE: 1, NAME: '待发货' },
  DELIVERING: { CODE: 3, NAME: '发货中' },
  FINISH: { CODE: 4, NAME: '已完成' },
  RETURNED: { CODE: 6, NAME: '已退回' }
  // ALL: { CODE: 0, NAME: '全部' }
};
const STATE_SALE = {
  ALL: { CODE: 0, NAME: '全部' },
  DRAFT: { CODE: 1, NAME: '草稿' },
  PROCESSING: { CODE: 2, NAME: '已提交' },
  CLOSE: { CODE: 6, NAME: '回签' }
};
const STATE_SUB_SALE = {
  ALL: { CODE: 0, NAME: '全部' },
  WAIT: { CODE: 1, NAME: '待排产' },
  QUEUING: { CODE: 2, NAME: '排产中' },
  WEAVE_DONE: { CODE: 3, NAME: '织造完成' },
  GOODS_ING: { CODE: 4, NAME: '备货中' },
  GOODS_DONE: { CODE: 5, NAME: '备货完成' },
  CLOSE: { CODE: 6, NAME: '完结' }
};
const STATE_SALE_ORDER = {
  STOCK: { CODE: [2, 3], NAME: '备货中' },
  DELIVER: { CODE: 4, NAME: '发货中' },
  CLOSE: { CODE: 6, NAME: '已完成' }
};
const STATE_CONFIRM_ORDER = {
  ALL: { CODE: 0, NAME: '全部' },
  WAIT: { CODE: 1, NAME: '待确认' },
  DELIVERING: { CODE: 2, NAME: '已确认' },
  SETTLEMENTING: { CODE: 3, NAME: '结算中' },
  BIND_FINANCE: { CODE: 4, NAME: '已冲销' }
};

const STATE_CARD_ORDER = {
  ALL: { CODE: 0, NAME: '全部' },
  SUBMIT: { CODE: 1, NAME: '待确认' },
  COMPLETE: { CODE: 2, NAME: '已确认' },
};

const STATE_INQUIRY = {
  ALL: { CODE: 0, NAME: '全部' },
  DRAFT: { CODE: 1, NAME: '草稿' },
  SUBMIT: { CODE: 2, NAME: '已提交' },
  REPLY: { CODE: 3, NAME: '已回复' },
  ORDER: { CODE: 4, NAME: '已下单' },
  CANCEL: { CODE: 5, NAME: '已取消' },
  // DELETED: { CODE: 9, NAME: '已删除' },
};

const STATE_PLAN_INQUIRY = {
  // ALL: { CODE: 0, NAME: '全部' },
  SUBMIT: { CODE: 1, NAME: '已提交' },
  SAVE: { CODE: 5, NAME: '暂存回复' },
  REPLY: { CODE: 2, NAME: '已回复' },
  ORDER: { CODE: 3, NAME: '已下单' },
  CANCEL: { CODE: 4, NAME: '已取消' },
  // DELETED: { CODE: 9, NAME: '已删除' },
};

const CONSTANT = {
  SYSTEM_NAME: '',
  SYSTEM_CODE: 5,
  SYSTEM_TYPE: '6',
  ATTRIBUTE_OBJ: { 1: 'input', 2: 'number', 3: 'date' },
  STATE_SETTING: {
    ALL: { CODE: 0, NAME: '全部' },
    AUDITED: { CODE: 1, NAME: '正常' },
    PROGRESSING: { CODE: 2, NAME: '禁用' }
  },
  STATE_SALE,
  STATE_SUB_SALE,
  STATE_NOTICE_ORDER,
  STATE_CONFIRM_ORDER,
  STATE_SALE_ORDER,
  STATE_CARD_ORDER,
  STATE_INQUIRY,
  STATE_PLAN_INQUIRY,
  GOODS_OBJ: {
    1: '成品',
    2: '坯布',
    3: '纱线'
  },
  SALE_CONTRACT_TYPE: {
    1: '销售合同',
    2: '试样合同'
  },
  NOTICE_TYPE: {
    1: '内销',
    2: '外销'
  },
  STATE_SALE_OBJ: code2obj(STATE_SALE),
  STATE_SUB_SALE_OBJ: code2obj(STATE_SUB_SALE),
  STATE_NOTICE_ORDER_OBJ: code2obj(STATE_NOTICE_ORDER),
  STATE_CONFIRM_ORDER_OBJ: code2obj(STATE_CONFIRM_ORDER),
  STATE_SALE_ORDER_OBJ: code2obj(STATE_SALE_ORDER),
  STATE_CARD_ORDER_OBJ: code2obj(STATE_CARD_ORDER),
  STATE_INQUIRY_OBJ: code2obj(STATE_INQUIRY),
  STATE_PLAN_INQUIRY_OBJ: code2obj(STATE_PLAN_INQUIRY)
};

export default CONSTANT;
